import { Roles } from "../../utils/access";

const audienceRoles = new Map([
  ["owner", Roles.Owner],
  ["admin", Roles.Admin],
  ["projectmanager", Roles.ProjectManager],
  ["user", Roles.User],
]);

export function normalizeReportAudience(value: unknown): number[] {
  if (value == null || (Array.isArray(value) && value.length === 0)) return [Roles.Owner, Roles.Admin];
  if (!Array.isArray(value)) return [];
  const roles = new Set<number>();
  for (const role of value) {
    const id = typeof role === "string" ? audienceRoles.get(role.toLowerCase()) : undefined;
    if (id === undefined) return [];
    roles.add(id);
  }
  return [...roles];
}

export function isReportAccessDenied(error: unknown): error is { status: 401 | 403 } {
  if (!error || typeof error !== "object" || !("status" in error)) return false;
  return error.status === 401 || error.status === 403;
}

export function reportFailureMessage(error: unknown, fallback: string): string {
  if (isReportAccessDenied(error)) {
    if ("status" in error && error.status === 401) return "Your session is no longer authorized. Sign in again to access reports.";
    if ("code" in error && error.code === "TIER_RESTRICTED") return "This operation is unavailable with your current subscription features.";
    return "You no longer have access to this report operation. Refresh access or contact your company Owner or Admin.";
  }
  return error instanceof Error && error.message ? error.message : fallback;
}
